import { action, createRequestTypes } from 'utils/actions'
import { change } from 'redux-form'

export const SETUPFORM_UPLOAD_IMAGE = createRequestTypes('SETUPFORM_UPLOAD_IMAGE')
export const SETUPFORM_DELETE_IMAGE = createRequestTypes('SETUPFORM_DELETE_IMAGE')
export const SETUPFORM_LOAD_IMAGE = createRequestTypes('SETUPFORM_LOAD_IMAGE')
export const SETUPFORM_CREATE_NEW_VENUE = createRequestTypes('SETUPFORM_CREATE_NEW_VENUE')

export const SETUPFORM_LOAD_EVENT_TYPES = 'SETUPFORM_LOAD_EVENT_TYPES'
export const SETUPFORM_LOAD = 'SETUPFORM_LOAD'
export const SETUPFORM_UPDATE_BASIC = 'SETUPFORM_UPDATE_BASIC'
export const SETUPFORM_UPDATE_ADVANCED = 'SETUPFORM_UPDATE_ADVANCED'
export const SETUPFORM_SUBMIT = 'SETUPFORM_SUBMIT'
export const SETUPFORM_LOAD_VENUE = 'SETUPFORM_LOAD_VENUE'
export const SETUPFORM_RESET_VENUE_SEARCH_RESULTS = 'SETUPFORM_RESET_VENUE_SEARCH_RESULTS'
export const SETUPFORM_SET_IS_NEW_VENUE = 'SETUPFORM_SET_IS_NEW_VENUE'
export const SETUPFORM_SET_NEW_VENUE = 'SETUPFORM_SET_NEW_VENUE'
export const SETUPFORM_UPDATE_NEW_VENUE = 'SETUPFORM_UPDATE_NEW_VENUE'
export const SETUPFORM_UPDATE_VENUE_SEARCH_RESULTS = 'SETUPFORM_UPDATE_VENUE_SEARCH_RESULTS'
export const SETUPFORM_DELETE = 'SETUPFORM_DELETE'
export const SETUPFORM_SET_AS_NO_VENUE = 'SETUPFORM_SET_AS_NO_VENUE'

export const uploadImage = {
  request: () => action(SETUPFORM_UPLOAD_IMAGE.REQUEST),
  success: response => action(SETUPFORM_UPLOAD_IMAGE.SUCCESS, { response }),
  failure: error => action(SETUPFORM_UPLOAD_IMAGE.FAILURE, { error }),
}

export const deleteImage = {
  request: () => action(SETUPFORM_DELETE_IMAGE.REQUEST),
  success: response => action(SETUPFORM_DELETE_IMAGE.SUCCESS, { response }),
  failure: error => action(SETUPFORM_DELETE_IMAGE.FAILURE, { error }),
}

export const loadImage = {
  request: () => action(SETUPFORM_LOAD_IMAGE.REQUEST),
  success: response => action(SETUPFORM_LOAD_IMAGE.SUCCESS, { response }),
  failure: error => action(SETUPFORM_LOAD_IMAGE.FAILURE, { error }),
}

export const createNewVenue = {
  request: () => action(SETUPFORM_CREATE_NEW_VENUE.REQUEST),
  success: response => action(SETUPFORM_CREATE_NEW_VENUE.SUCCESS, { response }),
  failure: error => action(SETUPFORM_CREATE_NEW_VENUE.FAILURE, { error }),
}

export const loadEventTypes = () =>
  action(SETUPFORM_LOAD_EVENT_TYPES)

export const loadSetupform = setupformId =>
  action(SETUPFORM_LOAD, { setupformId })

export const updateSetupformBasicDetails = (setupformId, values, resolve, reject) =>
  action(SETUPFORM_UPDATE_BASIC, { setupformId, values, resolve, reject })

export const updateSetupformAdvancedDetails = (setupformId, values, resolve, reject) =>
  action(SETUPFORM_UPDATE_ADVANCED, { setupformId, values, resolve, reject })

export const submitSetupform = (setupformId, resolve, reject) =>
  action(SETUPFORM_SUBMIT, { setupformId, resolve, reject })

export const loadVenue = venueId =>
  action(SETUPFORM_LOAD_VENUE, { venueId })

export const resetVenueSearchResults = () =>
  action(SETUPFORM_RESET_VENUE_SEARCH_RESULTS)

export const setIsNewVenue = isNewVenue =>
  action(SETUPFORM_SET_IS_NEW_VENUE, { isNewVenue })

export const setNewVenue = venue =>
  action(SETUPFORM_SET_NEW_VENUE, { venue })

export const updateNewVenue = venue =>
  action(SETUPFORM_UPDATE_NEW_VENUE, { venue })

export const updateVenueSearchResults = query =>
  action(SETUPFORM_UPDATE_VENUE_SEARCH_RESULTS, { query })

export const deleteSetupform = setupformId =>
  action(SETUPFORM_DELETE, { setupformId })

export const setVenueAsNoVenue = () =>
  action(SETUPFORM_SET_AS_NO_VENUE)

export const clearVenue = () => change("setupform", "venueId", null)



/** WEBPACK FOOTER **
 ** ./src/actions/setupform/setupform-actions.js
 **/